// extracted by mini-css-extract-plugin
export var text = "_2l-0";